/**
 * Mutable singleton config store, populated BEFORE the app tree loads.
 * Holds siteLocation and layersConfig fetched from Firestore.
 * Application config stays as build-time JSON (config.json) because
 * it contains MF URLs, theme, and Sentry settings needed at build time.
 */

import type { SiteLocationConfig } from './types'

const store = {
    siteLocation: null as SiteLocationConfig | null,
    layersConfig: null as Record<string, unknown> | null,
    _initialized: false,
}

export function setConfigs(configs: {
    siteLocation: Record<string, unknown>
    layersConfig: Record<string, unknown>
}) {
    store.siteLocation = configs.siteLocation as SiteLocationConfig
    store.layersConfig = configs.layersConfig
    store._initialized = true
}

export function isInitialized(): boolean {
    return store._initialized
}

export function getSiteLocation(): SiteLocationConfig {
    if (!store.siteLocation) {
        throw new Error(
            'ConfigStore: siteLocation config not loaded. Ensure initConfigs() completed before app start.',
        )
    }
    return store.siteLocation
}

export function getLayersConfig(): Record<string, unknown> {
    if (!store.layersConfig) {
        throw new Error(
            'ConfigStore: layersConfig config not loaded. Ensure initConfigs() completed before app start.',
        )
    }
    return store.layersConfig
}
